import React, { Component } from "react";
import { Button, CircularProgress, TextField, Typography } from "@material-ui/core";
import PaymentModal from "../PaymentModal/PaymentModal";
import requests from "../../Services/HttpServices";
import "./CreditsManager.scss";

let closeModalFixed = false;

const parseAmount = (amount) => {
	const parsed = parseFloat(`${amount}`.replace(",", "."));
	return Number.isNaN(parsed) ? 0 : parsed;
};

const formatCredits = (amount) => parseAmount(amount)
	.toFixed(2)
	.replace(".", ",");

const formatCreditQuantity = (amount) => {
	const formatted = formatCredits(amount);
	return formatted.endsWith(",00") ? formatted.replace(",00", "") : formatted;
};

class CreditsManager extends Component {
	constructor(props) {
		super(props);
		this.state = {
			amount        : "",
			balance       : 0,
			minBuy        : 10,
			loading       : true,
			submitting    : false,
			error         : "",
			paymentOrderId: null,
			paymentAmount : 0,
			paymentSuccess: false,
		};
	}

	componentDidMount() {
		this.loadBalance();
	}

	getLoggedUser() {
		try {
			return sessionStorage.getItem("User") && JSON.parse(sessionStorage.getItem("User")).userdata;
		} catch (e) {
			return null;
		}
	}

	loadBalance() {
		this.setState({ loading: true });
		requests("get", "creditBalance")
			.then((result) => {
				if (result && result.data && result.data.response === "success") {
					const data = result.data.data;
					this.setState({
						balance : parseAmount(data.balance),
						minBuy  : parseAmount(data.minBuy),
						amount  : this.state.amount || parseAmount(data.minBuy),
						error   : "",
					});
				} else {
					this.setState({ error: "Impossibile caricare i crediti disponibili." });
				}
				this.setState({ loading: false });
			})
			.catch(() => this.setState({
				loading : false,
				error   : "Impossibile caricare i crediti disponibili.",
			}));
	}

	createRechargeOrder() {
		const amount = parseAmount(this.state.amount);
		if (amount < parseAmount(this.state.minBuy)) {
			this.setState({ error: `La ricarica minima e' di ${formatCredits(this.state.minBuy)} Crediti DigitalMemorial.` });
			return;
		}

		this.setState({ submitting: true, error: "" });
		requests("post", "creditRecharge", { amount: amount.toFixed(2) })
			.then((result) => {
				if (result && result.response === "success") {
					this.setState({
						submitting    : false,
						paymentOrderId: result.data.orderid,
						paymentAmount : parseAmount(result.data.amount),
						paymentSuccess: false,
					});
				} else {
					this.setState({
						submitting : false,
						error      : result.message || "Impossibile creare l'ordine di ricarica.",
					});
				}
			})
			.catch(() => this.setState({
				submitting : false,
				error      : "Impossibile creare l'ordine di ricarica.",
			}));
	}

	closePayment(cancelOrder = true) {
		if (cancelOrder && this.state.paymentOrderId && !this.state.paymentSuccess) {
			requests("post", "creditCancelRecharge", { orderid: this.state.paymentOrderId });
		}
		this.setState({
			paymentOrderId: null,
			paymentAmount : 0,
			paymentSuccess: false,
		});
		this.loadBalance();
	}

	renderPaymentModal() {
		const user = this.getLoggedUser() || {};
		if (!this.state.paymentOrderId) return null;

		return (
			<div
				onClick={() => {
					if (!closeModalFixed) {
						this.closePayment(true);
					} else {
						closeModalFixed = false;
					}
				}}
				className="modalPurchase"
			>
				<div
					onClick={() => {
						closeModalFixed = true;
					}}
				>
					<PaymentModal
						paymentType="credits-recharge"
						setError={() => {}}
						price={this.state.paymentAmount}
						showAddress={false}
						successComponent={() => (
							<div className="credits-payment-success">
								<Typography className="success-title-fix">Ricarica completata</Typography>
								<Typography>I Crediti DigitalMemorial sono stati aggiunti al tuo saldo.</Typography>
								<Button
									variant="contained"
									color="primary"
									onClick={() => this.closePayment(false)}
								>
									Chiudi
								</Button>
							</div>
						)}
						onSuccess={() => {
							this.setState({ paymentSuccess: true });
							this.loadBalance();
						}}
						taxAddress={{}}
						userData={{
							name    : user.name,
							surname : user.surname,
							CF      : user.cf,
							email   : user.email,
						}}
						orderId={this.state.paymentOrderId}
						quantity={formatCreditQuantity(this.state.paymentAmount)}
						purchase="Ricarica Crediti DigitalMemorial"
					/>
				</div>
			</div>
		);
	}

	render() {
		return (
			<div className="credits-manager">
				{this.renderPaymentModal()}
				{this.state.loading ? (
					<div className="credits-manager-loading">
						<CircularProgress size={28} />
					</div>
				) : (
					<>
						<Typography className="credits-manager-title">Crediti disponibili</Typography>
						<Typography className="credits-manager-balance">
							{formatCredits(this.state.balance)}
							{" "}
							Crediti DigitalMemorial
						</Typography>
						<div className="credits-manager-form">
							<TextField
								label="Crediti da ricaricare"
								type="number"
								variant="outlined"
								size="small"
								value={this.state.amount}
								inputProps={{
									min  : this.state.minBuy,
									step : "0.01",
								}}
								onChange={(event) => this.setState({ amount: event.target.value })}
							/>
							<Button
								variant="contained"
								color="primary"
								disabled={this.state.submitting}
								onClick={() => this.createRechargeOrder()}
							>
								Ricarica
							</Button>
						</div>
						<Typography className="credits-manager-min">
							Ricarica minima:
							{" "}
							{formatCredits(this.state.minBuy)}
							{" "}
							Crediti DigitalMemorial
						</Typography>
						{this.state.error && <Typography className="credits-manager-error">{this.state.error}</Typography>}
					</>
				)}
			</div>
		);
	}
}

export default CreditsManager;
